import { Injectable } from '@angular/core';
import { NbIconLibraries } from '@nebular/theme';
import { agentSetupIcon } from '../../assets/icons/agent-setup';
import { aiMagicIcon } from '../../assets/icons/ai-magic';
import { assistantIcon } from '../../assets/icons/assistant';
import { attachmentIcon } from '../../assets/icons/attachment';
import { chatStylingIcon } from '../../assets/icons/chat-styling';
import { copyApiKeyIcon } from '../../assets/icons/copy-api-key';
import { coursesIcon } from '../../assets/icons/courses';
import { curriculumIcon } from '../../assets/icons/curriculum';
import { eventChat } from '../../assets/icons/events/event-chat';
import { eventExerciseAnswered } from '../../assets/icons/events/event-exercise-answered';
import { eventExerciseCompleted } from '../../assets/icons/events/event-exercise-completed';
import { eventExerciseStart } from '../../assets/icons/events/event-exercise-start';
import { eventLiveAction } from '../../assets/icons/events/event-live-action';
import { eventPageNavigation } from '../../assets/icons/events/event-page-navigation';
import { eventSessionEnd } from '../../assets/icons/events/event-session-end';
import { eventSesseionStart } from '../../assets/icons/events/event-session-start';
import { eventSupport } from '../../assets/icons/events/event-support';
import { eventThumbs } from '../../assets/icons/events/event-thumbs';
import { filesIcon } from '../../assets/icons/files';
import { iliasIcon } from '../../assets/icons/ilias';
import { integrationIcon } from '../../assets/icons/integration';
import { knowledgeBaseIcon } from '../../assets/icons/knowledge-base';
import { linkIcon } from '../../assets/icons/link';
import { loginIcon } from '../../assets/icons/login';
import { logoutIcon } from '../../assets/icons/logout';
import { magicWandIcon } from '../../assets/icons/magic-wand';
import { moodleIcon } from '../../assets/icons/moodle';
import { orbiIcon } from '../../assets/icons/orbi';
import { organisationIcon } from '../../assets/icons/organisation';
import { paymentIcon } from '../../assets/icons/payment';
import { productsIcon } from '../../assets/icons/products';
import { settingsIcon } from '../../assets/icons/settings';
import { stripeIcon } from '../../assets/icons/stripe';
import { usageIcon } from '../../assets/icons/usage';
import { userIcon } from '../../assets/icons/user';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor(private iconLibraries: NbIconLibraries) {
    this.iconLibraries.registerSvgPack('al', {
      attachment: attachmentIcon,
      user: userIcon,
      files: filesIcon,
      integration: integrationIcon,
      link: linkIcon,
      login: loginIcon,
      logout: logoutIcon,
      organisation: organisationIcon,
      usage: usageIcon,
      payment: paymentIcon,
      plan: productsIcon,
      settings: settingsIcon,
      aiMagic: aiMagicIcon,
      magicWand: magicWandIcon,
      agentSetup: agentSetupIcon,
      // Agent-Symbol ist Orbi. `tutors` (der frühere Roboter) ist nirgends
      // mehr eingesetzt — für einen Agent `orbi` nehmen.
      orbi: orbiIcon,
      tutors: assistantIcon,
      knowledge: knowledgeBaseIcon,
      copyKey: copyApiKeyIcon,
      chatStyling: chatStylingIcon,
      courses: coursesIcon,
      curriculum: curriculumIcon,
      moodle: moodleIcon,
      ilias: iliasIcon,
      stripe: stripeIcon,
      // Event Icons
      chat_message: eventChat,
      exercise_answered: eventExerciseAnswered,
      exercise_mode_completed: eventExerciseCompleted,
      exercise_set_completed: eventExerciseCompleted,
      exercise_mode_started: eventExerciseStart,
      exercise_set_started: eventExerciseStart,
      live_action: eventLiveAction,
      page_navigation: eventPageNavigation,
      session_start: eventSesseionStart,
      session_end: eventSessionEnd,
      support_request: eventSupport,
      thumb: eventThumbs,
    });
  }
}
